import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { FaWhatsapp } from "react-icons/fa";
import "swiper/css";
import "swiper/css/effect-fade";
import pool_030 from "./images/pool_030.jpg";
import common_021 from "./images/common_021.jpg";
import exterior_015 from "./images/exterior_015.jpg";
import room_003 from "./images/room_003.jpg";
import exterior_023 from "./images/exterior_023.jpg";

function Hero() {
  try {
    const sliderImages = [
      { src: exterior_015, alt: "Main Banner" },
      { src: exterior_023, alt: "Front View" },
      { src: room_003, alt: "Main Banner" },
      { src: pool_030, alt: "Swimming Pool" },
      { src: common_021, alt: "Main Banner" },
    ];
    return (
      <section
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
        data-name="hero"
        data-file="components/Hero.js"
      >
        {/* Swiper Slider as Background */}
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          loop={true}
          className="absolute inset-0 w-full h-full z-0"
        >
          {sliderImages.map((img, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url(${img.src})`,
                  width: "100%",
                  height: "100vh",
                }}
                aria-label={img.alt}
              ></div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Modern Overlay */}
        <div className="hero-overlay"></div>
        {/* Content */}
        <div className="absolute z-10 text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-6xl md:text-8xl font-serif font-bold mb-8 text-shadow leading-tight">
            Angelo's Farm
          </h1>
          <p className="text-2xl md:text-3xl mb-6 text-shadow font-light">
            A Home Away from Home
          </p>
          <p className="text-xl md:text-2xl mb-10 max-w-3xl mx-auto text-shadow-light leading-relaxed">
            Experience luxury in our 8BHK villa with pool, garden, and premium
            amenities in the serene location of Kukas, Jaipur
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://wa.me/919256828782"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg px-8 py-4 rounded-xl font-semibold transition-all duration-300  text-[#B86A4B] bg-white hover:bg-[#B86A4B] hover:text-white flex items-center"
            >
              <FaWhatsapp size={30} style={{ marginRight: "6px" }} />
              DM to Book
            </a>
            <a
              href="tel:+918949348052"
              className="text-lg px-8 py-4 rounded-xl font-semibold transition-all duration-300  text-[#B86A4B] bg-white hover:bg-[#B86A4B] hover:text-white flex items-center"
            >
              <div className="icon-phone text-lg mr-2 inline-block"></div>
              Call Now
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
          <div className="icon-chevron-down text-2xl"></div>
        </div>
      </section>
    );
  } catch (error) {
    console.error("Hero component error:", error);
    return null;
  }
}

export default Hero;
